import { CustomField, CustomFieldInstance } from '../types'

export function formatCustomFieldDisplayValue(
  instance: CustomFieldInstance,
  fieldDef?: Pick<CustomField, 'data_type' | 'extra_data'> | null,
): string {
  const field = fieldDef ?? instance.field_display
  const value = instance.value
  if (value == null || value === '') return ''

  const dataType = field?.data_type
  if (dataType === 'select') {
    const options = field?.extra_data?.select_options ?? []
    const match = options.find((o) => o.id === value)
    return match?.label ?? String(value)
  }

  if (typeof value === 'object') {
    return JSON.stringify(value)
  }

  return String(value)
}
